import React from 'react';
import { motion } from 'framer-motion';
interface ProgressBarProps {
  current: number;
  total: number;
}
export function ProgressBar({
  current,
  total
}: ProgressBarProps) {
  const progress = Math.min(100, current / total * 100);
  return <div className="w-full max-w-md mx-auto mb-3" data-id="element-10">
      <div className="flex justify-center text-xs font-medium text-gray-500 mb-1.5" data-id="element-11">
        <span data-id="element-12">
          Question {current} of {total}
        </span>
      </div>
      <div className="h-1.5 w-full bg-gray-200 rounded-full overflow-hidden" data-id="element-13">
        <motion.div className="h-full bg-brand-primary rounded-full" initial={{
        width: 0
      }} animate={{
        width: `${progress}%`
      }} transition={{
        duration: 0.5,
        ease: 'easeInOut'
      }} data-id="element-14" />
      </div>
    </div>;
}